import { api } from "./api";
import {
  TOTPEnableResponse,
  TOTPSetupResponse,
  TOTPStatus,
  TOTPVerifyResponse,
} from "../types";

// fetchTOTPStatus carrega o estado atual (enrolado ou não, quantos
// backup codes restam). Roda atrás do bearer middleware.
export function fetchTOTPStatus() {
  return api<TOTPStatus>("/auth/totp/status");
}

export function setupTOTP() {
  return api<TOTPSetupResponse>("/auth/totp/setup", { method: "POST" });
}

export function enableTOTP(code: string) {
  return api<TOTPEnableResponse>("/auth/totp/enable", {
    method: "POST",
    body: JSON.stringify({ code }),
  });
}

export function disableTOTP(code: string) {
  return api<{ status: string }>("/auth/totp/disable", {
    method: "POST",
    body: JSON.stringify({ code }),
  });
}

export function regenerateBackupCodes(code: string) {
  return api<TOTPEnableResponse>("/auth/totp/regenerate-backup-codes", {
    method: "POST",
    body: JSON.stringify({ code }),
  });
}

// verifyTOTP é chamado direto via fetch (sem `api` wrapper) porque o
// caller no momento do login multi-fator NÃO tem session token ainda —
// só o pending_token. O wrapper api() injeta Authorization header com
// session token, o que iria mascarar o pending_token.
export async function verifyTOTP(
  pendingToken: string,
  code: string,
): Promise<TOTPVerifyResponse> {
  const res = await fetch("/admin/v1/auth/totp/verify", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ pending_token: pendingToken, code }),
  });
  if (!res.ok) {
    let message = `HTTP ${res.status}`;
    let code = "INTERNAL_ERROR";
    try {
      const body = (await res.json()) as { code?: string; error?: string };
      code = body.code ?? code;
      message = body.error ?? message;
    } catch {
      /* not JSON */
    }
    const err = new Error(message) as Error & { status: number; code: string };
    err.status = res.status;
    err.code = code;
    throw err;
  }
  return (await res.json()) as TOTPVerifyResponse;
}
